<template>
  <div>
    <x-dialog
        :show="show"
        persistent
        maxwidth="480"
    >
      <x-card>
        <v-card-title class="text-h5">
          Upload Profile Picture
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-4">
          <v-form
              ref="form"
              v-model="valid"
              lazy-validation
          >
            <v-file-input
                label="Select image file to upload"
                :rules="rules"
                dense
                outlined
                v-model="picture"
                accept=".jpg,.jpeg,.png"
            ></v-file-input>
          </v-form>
          <div class="text-center error--text" v-if="error">{{errorMessage}}</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="close" :disabled="uploading">Cancel</v-btn>
          <v-btn text color="primary" @click="uploadProfilePicture" :disabled="uploading || !valid || picture == null" :loading="uploading">Upload</v-btn>
        </v-card-actions>
      </x-card>
    </x-dialog>
    <loading-dialog :show="loading"></loading-dialog>
    <message-box :show="messageShow" :message="message" :type="messageType" v-on:close-message="messageShow = !messageShow"></message-box>
  </div>
</template>

<script>
import LoadingDialog from "@ui/components/LoadingDialog";
import MessageBox from "@ui/components/MessageBox";
import Api from "@/main/api";
import ErrorResolver from "@/shared/ErrorResolver";
import XDialog from "@ui/components/XDialog.vue";
import XCard from "@ui/components/XCard.vue";
export default {
  name: "ProfilePictureUpload",
  components: {XCard, XDialog, MessageBox, LoadingDialog},
  props: ["user", "show"],
  data: () => ({
    picture: null,
    error: false,
    errorMessage: '',
    uploading: false,
    messageType: '',
    message: '',
    messageShow: false,
    loading: false,
    valid: false,
    rules: [
      file => !file || file.size < ((1/2) * 1024 * 1024) || 'Image size should be less than 500Kb!'
    ],
  }),

  methods: {
    close(){
      this.picture = null
      this.$refs.form.reset()
      this.$emit("close");
    },

    uploadProfilePicture(){
      this.$refs.form.validate();
      if(this.valid){
        this.loading = true;
        this.uploading = true
        const fData = new FormData();
        fData.append("file", this.picture);
        fData.append("user", this.user.userId);

        Api.profilePicture.store(fData)
        .then(res => {
          if(res.data != null){
            this.messageType = "success";
            this.message = "Uploaded successfully"
            this.messageShow = true;
            this.close()
            this.$emit('uploaded')
          } else{
            this.messageType = "error";
            this.message = "Upload failed"
            this.messageShow = true;
          }
        }).catch(err => ErrorResolver.checkErrors(this, err))
        .finally(() => {
          this.loading = this.uploading = false;
        })
      }
    }

  }
}
</script>

<style scoped>

</style>
